import Vue from 'vue';
import VueRouter from 'vue-router';
import { sessionData } from "../storage/storage";
import Login from '../views/login/Login.vue';
import LoginAuto from '../views/login/LoginAuto.vue';
import Index from '../views/Index.vue';

  import LocalData from '../views/local/LocalData.vue';
  import ExternalPage from '../views/iframe/ExternalPage.vue';
  import ReceivingRecord from '../views/record/ReceivingRecord.vue';
  import OutputRecord from '../views/record/OutputRecord.vue';
  import TeamManagement from '../views/team/TeamManagement.vue';
  import PersonalInfo from '../views/personal/PersonalInfo.vue';

Vue.use(VueRouter)
const routes = [
  { 
    path: '/', 
    redirect: '/Login' 
  },
  { 
    path: '/Login', 
    component: Login 
  },
  { 
    path: '/LoginAuto', 
    component: LoginAuto 
  },
  { 
    path: '/Index', 
    component: Index,
    children: [
      { path: '/', redirect: '/LocalData' },
      { 
        path: '/LocalData', 
        component: LocalData,
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/ExternalPage', 
        component: ExternalPage,
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/ReceivingRecord', 
        component: ReceivingRecord,
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/OutputRecord', 
        component: OutputRecord,
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/TeamManagement', 
        component: TeamManagement,
        meta: {
          requireAuth: true,  
        }  
      },
      { 
        path: '/PersonalInfo', 
        component: PersonalInfo,
        meta: {
          requireAuth: true,  
        }  
      },
    ]
  },
]
const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (sessionData('get','token')) {  // 获取当前的token是否存在
      next();
    } else {
      next('/Login')
    }
  }else { // 如果不需要权限校验，直接进入路由界面
    next();
  }
});
export default router;
